import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import App from './App';
import { ConfirmDialogHost } from './components/ui/ConfirmDialog';
import { registerServiceWorker } from './lib/pwa';
import './i18n';
import './index.css';

// Error reporting — no-op without VITE_SENTRY_DSN, so safe to ship unconfigured.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  Sentry.init({ dsn: sentryDsn, environment: import.meta.env.MODE, tracesSampleRate: 0.1 });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <ConfirmDialogHost />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

// Installable PWA + offline app shell (production only).
registerServiceWorker();
